/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { changeUserActivation, CheckLogin, GetAllUsers } from "../../API/Pins";
import { store } from "../../Context/Store";
import { Redirect } from "react-router-dom";
import Table from "../../Components/Table";
import { columns } from "./columns";
import Modal from "../../Components/Modal";
import useModal from "../../utils/hooks";
import AddUserModal from "../../Components/AddUserModal";

const UsersDashboard = ({ history }) => {
  const { OpenModal: addUserModal, toggle: toggleAddUser } = useModal();

  const context = useContext(store);
  const { dispatch } = context;

  const TableRef = useRef();

  const [CheckAuth, setCheckAuth] = useState(true);
  const [Users, setUsers] = useState([]);
  const [UpdateUserState, setUpdateUserState] = useState({
    res: null,
    loading: null,
  });

  useEffect(() => {
    if (UpdateUserState.res) {
      GetAllUsersList();
    }
  }, [UpdateUserState.res]);

  const handleChangeActivation = async (userId, state) => {
    try {
      setUpdateUserState({
        res: null,
        loading: true,
      });
      await changeUserActivation({
        user_id: userId,
        is_active: state,
      });
      setUpdateUserState({
        res: true,
        loading: false,
      });
    } catch (error) { }
    setUpdateUserState({
      res: null,
      loading: false,
    });
  };

  useEffect(() => {
    const CheckAuth = async () => {
      try {
        const res = await CheckLogin();
        if (res?.data?.role === "Admin") {
          dispatch({ type: "SET_ROLE", role: res?.data?.role });
          setCheckAuth(res?.data?.role);
        }
      } catch (error) {
        setCheckAuth(false);
      }
    };

    CheckAuth();
  }, []);

  const [query, setQuery] = useState({})

  console.log(query, "query")

  const GetAllUsersList = async (query) => {
    try {
      if (CheckAuth === "Admin") {
        const users = await GetAllUsers(query);
        setUsers(users?.data);
      }
    } catch (error) {
      setUsers([]);
    }
  };
  useEffect(() => {
    GetAllUsersList(query);
  }, [CheckAuth, query]);

  if (!CheckAuth) {
    return <Redirect to="/login" />;
  }

  console.log(Users ,"Users")
  return (
    <div className="flex flex-col">
      <div className="w-full py-6 px-4 flex items-center justify-between">
        <div className="flex items-center">
          <span
            className="mx-4 text-base font-medium cursor-pointer justify-center"
            onClick={() => history.push("/")}
          >
            Maps
          </span>
          <span className="mx-4 text-base font-medium cursor-pointer text-blue">
            Users
          </span>
          <span
            className="mx-4 text-base font-medium cursor-pointer"
            onClick={() => history.push("/admin/contracts")}
          >
            Contracts
          </span>
        </div>
        <div
          onClick={toggleAddUser}
          className="text-blue text-lg font-medium cursor-pointer"
        >
          + Add User
        </div>
      </div>

      <Table
        columns={columns(handleChangeActivation, UpdateUserState.loading)}
        // tableFetchApi={GetAllUsersList}
        setQuery={setQuery}
        tableData={Users}
        tableLoading={false}
        tableName="users-list"
        ref={TableRef}
      />

      {addUserModal && (
        <Modal title="Add User" closeModal={toggleAddUser}>
          <AddUserModal
            closeModal={toggleAddUser}
            refetchData={GetAllUsersList}
          />
        </Modal>
      )}
    </div>
  );
};

export default UsersDashboard;
